exports.localizeUrl = (path, lang) => {
  if (lang === "de") {
    if (path === "/" || path === "") {
      return "/de";
    } else {
      return path + "-de";
    }
  }
  return path;
};
